import {mediaFrameUIParams} from '../../constants/media-frame-ui-params/media-frame-ui-params.constant';
import {IBrowserUtilsService} from '@techsee/techsee-client-infra/lib/services/BrowserUtilsService';
import {ITsResponsiveUtilsService} from '../ts-responsive-utils/ts-responsive-utils.service';
import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';
import {getRootStore} from '../../app.bootstrap';

interface IPadding {
    width: number;
    height: number;
}

interface IInterfaceTypes {
    old: string;
    new: string;
}

export interface ITsInterfaceHelperService {
    useNewInterface: boolean;
    mediaFrameHeightPadding: number;
    mediaFrameWidthPadding: number;
    mediaFrameHeightPaddingMobile: number;
    mediaFrameWidthPaddingMobile: number;
    getPadding: IPadding;
    setInterfaceType(useNew: boolean): string;
    setHeaderFooterLeftbarType(isNew: boolean): string;
}

export class TsInterfaceHelperService implements ITsInterfaceHelperService {
    private interfaceTypes: IInterfaceTypes;
    private headerFooterLeftbarTypes: IInterfaceTypes;

    constructor(
        private browserUtilsService: IBrowserUtilsService,
        private responsiveUtils: ITsResponsiveUtilsService,
        private environmentDetect: ITsEnvironmentDetect
    ) {
        this.interfaceTypes = {
            old: 'old',
            new: 'new'
        };
        this.headerFooterLeftbarTypes = {
            old: 'old',
            new: 'new'
        };
    }

    get useNewInterface(): boolean {
        const interfaceType = this.browserUtilsService.getFromLocalStorage('interfaceType');
        return interfaceType ? interfaceType === this.interfaceTypes.new : false;
    }

    get mediaFrameHeightPadding(): number {
        const interfacePadding = this.useNewInterface
            ? mediaFrameUIParams.HEIGHT_PADDING_NEW
            : mediaFrameUIParams.HEIGHT_PADDING;
        const footerPadding = mediaFrameUIParams.NEW_FOOTER_PADDING;

        return interfacePadding + footerPadding;
    }

    get mediaFrameWidthPadding(): number {
        return this.useNewInterface ? mediaFrameUIParams.WIDTH_PADDING_NEW : mediaFrameUIParams.WIDTH_PADDING;
    }

    get mediaFrameHeightPaddingMobile(): number {
        return this.responsiveUtils.isPortrait()
            ? mediaFrameUIParams.MOBILE_DASHBOARD_HEIGHT_PADDING_PORTRAIT
            : mediaFrameUIParams.MOBILE_DASHBOARD_HEIGHT_PADDING_LANDSCAPE;
    }

    get mediaFrameWidthPaddingMobile(): number {
        return this.responsiveUtils.isPortrait()
            ? mediaFrameUIParams.MOBILE_DASHBOARD_WIDTH_PADDING_PORTRAIT
            : mediaFrameUIParams.MOBILE_DASHBOARD_WIDTH_PADDING_LANDSCAPE;
    }

    get getPadding(): IPadding {
        const isMobile = this.environmentDetect.isMobile(
            this.browserUtilsService.getFromLocalStorage('displayTabletAsDesktop')
        );

        return isMobile
            ? {width: this.mediaFrameWidthPaddingMobile, height: this.mediaFrameHeightPaddingMobile}
            : {width: this.mediaFrameWidthPadding, height: this.mediaFrameHeightPadding};
    }

    setInterfaceType(useNew: boolean): string {
        const value = useNew ? this.interfaceTypes.new : this.interfaceTypes.old;
        this.browserUtilsService.saveToLocalStorage('interfaceType', value);
        return value;
    }

    setHeaderFooterLeftbarType(isNew: boolean): string {
        const value = isNew ? this.headerFooterLeftbarTypes.new : this.headerFooterLeftbarTypes.old;
        this.browserUtilsService.saveToLocalStorage('headerFooterLeftbarType', value);
        return value;
    }
}
